<template>
  <v-container>
    <v-row class="align-stretch justify-center">
      <v-col class="col-xs-12">
        <v-card flat align-center>
          <v-card-title class="headline">
            Redefinição de senha
          </v-card-title>
          <v-card-subtitle>
            Para acessar o sistema, redefina sua senha.
          </v-card-subtitle>
          <v-form ref="resetPwdForm" :value="resetPwdFormValid">
          <v-card-text>
             <v-row>
                <v-col class="col-sm-12 col-md-6">
                <Label class="mb-1">Nova Senha</Label>
                    <v-text-field
                    dense
                    :type="showPassword?'text':'password'"
                    v-model="formData.password"
                    outlined
                    placeholder="Nova senha"
                    :rules="formRules.password"
                    :append-icon="showPassword?'fa-eye-slash':'fa-eye'"
                    @click:append="showPassword = !showPassword"
                    ></v-text-field>
                </v-col>
             </v-row>
            <v-row>
                <v-col class="col-sm-12 col-md-6">
                    <Label class="mb-1">Confirmação de Senha</Label>
                    <v-text-field
                        dense
                        :type="showPasswordConfirm?'text':'password'"
                        v-model="formData.passwordConfirm"
                        outlined
                        placeholder="Confirme a nova senha"
                        :rules="[v => v == formData.password || 'As senhas não conferem.']"
                        :append-icon="showPasswordConfirm?'fa-eye-slash':'fa-eye'"
                        @click:append="showPasswordConfirm = !showPasswordConfirm"
                        ></v-text-field>
                </v-col>
            </v-row>
          </v-card-text>
            <v-card-actions class="col-xm-12 col-sm-12 col-md-6 py-3 pl-5 pr-6">
              <v-row>
                <v-col class="col-xm-8 col-sm-8 col-md-10 py-0">
                    {{requestAnswer}}
                </v-col>
                <!-- <v-col class="col-sm-4 col-md-2 py-0"> -->
                <v-spacer></v-spacer>
                <v-btn class="elevation-0" color="primary" @click="sendData">Enviar</v-btn>
                <!-- </v-col> -->
              </v-row>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
        formData: {
          oldPassword: null,
          password: null,
          passwordConfirm: null
        },
        requestAnswer:'Use 6 ou mais caracteres com uma mistura de letras maiúsculas, minúsculas, números e símbolos. Não use uma senha igual a recebida.',
        resetPwdFormValid: true,
        showPassword: false,
        showPasswordConfirm: false
    };
  },
  computed: {
      ...mapState({
          formRules: state => state.formRules,
          userData: state => state.userData
      })
  },
  props: {
      saveNewPwd: Function
  },
  mounted() {
    Array.from(document.getElementsByTagName("input")).forEach(el => el.setAttribute('autocomplete', 'off'))
  },
  methods: {
    sendData(){
      if(this.$refs.resetPwdForm.validate()){
        this.saveNewPwd(this.formData)
      }
    }
  }
};
</script>